import firebase from "firebase/app";
import "firebase/auth";

// Invisible reCAPTCHA verifier required by Firebase Auth's phone-based flows
// (MFA enrollment and MFA sign-in challenge). One instance per DOM container -
// callers must render a <div :id="containerId"> before calling this.
export function createRecaptchaVerifier(containerId: string): firebase.auth.RecaptchaVerifier {
  return new firebase.auth.RecaptchaVerifier(containerId, { size: "invisible" }, firebase.app());
}
